import { filterParams, formatPics } from '@/common/utils/format'
import { get } from 'lodash-es'
import { i18n, getBDCountry } from '@/common/utils/i18n'
const country = getBDCountry() || 'MX'

export function revert (data = {}) {
  const sign = get(data, 'contractGlobal.authorizationInfo.sign')
  let revertted = {}
  if (sign) {
    revertted = {
      ...sign,
      authorizedPics: formatPics(sign.authorizedPics),
      extraFiles: formatPics(sign.extraFiles),
      pics: formatPics(sign.pics)
    }
  }
  return revertted
}

export function  submitFormat (sign) {
    let payment = get(this, 'signForm.payAuthInfo') || {}
    payment = Object.keys(payment).reduce((target, key) => {
      target[key] = payment[key].map(d => d.key)
      return target
    }, {})
    const json = {
      source: 'contractor',
      queryId: this.$route.params.id,
      contractGlobal: {
        authorizationInfo: {
          sign,
          payment
        }
      }
    }
    return {
      params: JSON.stringify(json)
    }
  }

export default {
  revert,
  submitFormat
}
